export const parseSchedPatternFromLog = (log) => {
  const schedule = log?.schedule?.scheduleArray ?? [];
  const scheduleName = schedule[0]?.day || "";
  const selectedOption = log?.schedule?.selectedOption || "";

  const graveyardMatch = scheduleName.match(
    /^Graveyard (\d+)days Working, (\d+)days off$/
  );
  const regularMatch = scheduleName.match(
    /^Regular (\d+)days Working, (\d+)days off$/
  );
  const plainCycleMatch = scheduleName.match(
    /^(\d+)days Working, (\d+)days off$/
  );

  const alternateMWFMatch = selectedOption === "Alternate (MWF)";
  const alternateTTHSMatch = selectedOption === "Alternate (TTHS)";
  const isAlternateSchedule = alternateMWFMatch || alternateTTHSMatch;

  const workingDaysAlt = alternateMWFMatch
    ? ["Monday", "Wednesday", "Friday"]
    : alternateTTHSMatch
    ? ["Tuesday", "Thursday", "Saturday"]
    : [];

  const matchedSchedule = graveyardMatch || regularMatch || plainCycleMatch;

  const twoDayGraveyardMatchList = [];
  if (selectedOption === "Graveyard") {
    for (const sched of schedule) {
      const name = sched?.day || "";
      const match = name.match(/^(\w+) - (\w+)$/);
      if (match) {
        twoDayGraveyardMatchList.push({
          match,
          timein: sched.timein,
          timeout: sched.timeout,
          earliestTimeOut: sched.earliestTimeOut,
          lateTimeIn: sched.lateTimeIn,
        });
      }
    }
  }

  if (matchedSchedule) return { matchedSchedule };
  if (twoDayGraveyardMatchList.length > 0) return { twoDayGraveyardMatchList };
  if (isAlternateSchedule) return { workingDaysAlt };
  return { selectedOption: schedule };
};
